import React from "react";
import style from "./spinner.module.css";

export function Spinner(): JSX.Element {
  return <div className={style.loader} />;
}
